// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesChannelContentEditor-SalesChannelEditorHeader-PromotionBarContent-style__container--zXFKy"};